import { IntlShape } from "react-intl";

import Price from "@mapmycustomers/shared/types/plans/Price";

const formatPrice = (intl: IntlShape, price: Price, precision: number = 0) =>
  intl.formatNumber(price.value, {
    currency: price.currency,
    minimumFractionDigits: precision,
    style: "currency",
  });

export default formatPrice;
